export default __webpack_public_path__ + "fafcbde4291de34d118b145f1bb451fb.pdf";